<div class="flex flex-row w-full items-center">
    <div class="w-4">
        <span class="text-headline-6 select-none text-on-primary-container">{{ layerAttributeFormId() }}</span>
    </div>
    <app-select
        class="w-80"
        [isDisabled]="editDisabled() || isLoading()"
        [options]="layerAttributesOptions()"
        [placeholder]="'mapFilter.selectLayerColumn' | transloco"
        [(selectedOptions)]="selectedColumnOption"
        (optionSelected)="setValue(LayerAttributeFormKeys.COLUMN, $event)" />

    <app-select
        class="w-48 ml-2"
        [isDisabled]="editDisabled()"
        [options]="attributeComparatorOptions"
        [placeholder]="'mapFilter.comparator' | transloco"
        [(selectedOptions)]="selectedComparatorOption"
        (optionSelected)="setValue(LayerAttributeFormKeys.COMPARATOR, $event)" />

    <app-select
        class="ml-2"
        emptyOptionLabel="mapFilter.noValueSuggested"
        [class]="isLoading() || hasTooManyDistinctValues() ? 'w-52' : 'w-60'"
        [defaultValue]="currentValue()"
        [inputFormControl]="layerAttributeForm().controls.value"
        [isDisabled]="editDisabled()"
        [options]="layerAttributeValueOptions()"
        [resetForce]="resetValueColumn()"
        [(selectedOptions)]="selectedValueOption"
        (optionSelected)="setValue(LayerAttributeFormKeys.VALUE, $event)" />

    @if (isLoading()) {
        <div class="max-w-8 w-8">
            <app-loading
                [hasMessage]="false"
                [size]="20"
                [strokeWidth]="2" />
        </div>
    }

    @if (hasTooManyDistinctValues()) {
        <div class="max-w-8 w-8">
            <fa-icon
                class="pl-2 text-custom-orange"
                [icon]="['fas', 'warning']"
                [matTooltip]="'mapFilter.maximumAttributeValueExceeded' | transloco" />
        </div>
    }
    <button
        class="pl-2 bg-transparent border-none"
        type="button"
        [disabled]="editDisabled() || isLoading()"
        (click)="remove.emit()">
        <fa-icon
            size="xl"
            [icon]="['fas', 'trash']" />
    </button>
</div>
